import {helpers} from '@/ft-vue-core'
import {itemDefault, detailDefault, dataDefaults} from '../util/defaults'

const {deepClone} = helpers

export default {
  data: function () {
    return {
      type: 'Reservation',
      types: 'Reservation',
      apiRecordCommand: 'diningReservation',
      itemDefault: itemDefault,
      detailDefault: detailDefault,
      showTableNumberUsageDialog: false,
      noTimeSelected: false,
      ...deepClone(dataDefaults),
      lastMemberFilter: {
        mType: null,
        mShip: null,
        group: null,
        name: null,
        result: []
      }
    }
  }
}


